import type { MouseEvent } from 'react';

import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { H4 } from '@liveauctioneers/hammer-ui-core/text';

type Props = {
    readonly houseName: string;
    readonly isHouse?: boolean;
    readonly onBack: (event: MouseEvent<HTMLDivElement>) => void;
    readonly testid?: string;
};

export const ClosedConversationPrompt = ({
    houseName,
    isHouse,
    onBack,
    testid = 'messengerClosedConversationPrompt',
}: Props) => (
    <>
        <div
            className="flex flex-col items-center justify-center border border-border-secondary bg-surface-100 px-lg pb-md pt-[23px] text-center"
            data-testid={testid}
        >
            <H4>This conversation is marked closed.</H4>
            {!isHouse && <H4>Please send {houseName} a new message if you have a question.</H4>}
        </div>
        <div
            className="my-[20px] flex items-center justify-end"
            aria-label="Back to inbox"
            onClick={onBack}
        >
            <Button>Back to Inbox</Button>
        </div>
    </>
);
